import { useFormikContext } from 'formik';
import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import { useAppContext } from '@contexts/AppContext';
import { Theme } from '@interfaces/global';
import { subscribe_path } from '@routes';
import { LeadType } from '@utils/types';

import { FormValues } from '.';
import LeadCaptureModalBody from '../../LeadCaptureModalBody';

interface SignUpFormProps {
  buttonText: string;
  leadType: LeadType;
}

const SignUpForm = ({ buttonText, leadType }: SignUpFormProps) => {
  const { values } = useFormikContext<FormValues>();
  const { isGdprRequired, initialCurrentUser } = useAppContext();

  return (
    <div className="flex justify-center">
      {initialCurrentUser ? (
        <PrimaryButton as="link" href={subscribe_path({ offer: values.selectedOffer })}>
          {buttonText}
        </PrimaryButton>
      ) : (
        <LeadCaptureModalBody
          buttonText={buttonText}
          leadType={leadType}
          includeSignInOption={false}
          offerLink={subscribe_path({ offer: values.selectedOffer })}
          gdpr={isGdprRequired}
          theme={Theme.Light}
          withOauth={false}
          emailLeadCaptureClassName="w-full"
        />
      )}
    </div>
  );
};

export default SignUpForm;
